/**
 * Cart drawer additions: the Buy 2 Get 2 progress bar, the free shipping
 * threshold line, and the package protection toggle.
 *
 * Liquid renders the opening state. This reacts to changes the same way the
 * header badge does - the theme's cart events plus a fetch wrapper for writes
 * it does not announce - and always re-reads /cart.js rather than counting
 * locally, so the numbers cannot drift from Shopify's.
 */
(function () {
  var GOAL_FALLBACK = 4;
  var timer = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render(cart) {
    var wrap = document.querySelector('[data-bb-cart-extras]');
    if (wrap) {
      var goal = parseInt(wrap.getAttribute('data-goal'), 10) || GOAL_FALLBACK;
      var shipAt = parseInt(wrap.getAttribute('data-ship-threshold'), 10) || 10000;
      var count = cart.item_count;

      var pips = wrap.querySelectorAll('.bb-cart-progressbar__pip');
      for (var i = 0; i < pips.length; i++) {
        pips[i].classList.toggle('is-on', i < Math.min(count, goal));
      }

      var msg = wrap.querySelector('[data-bb-progress-msg]');
      if (msg) {
        var left = goal - count;
        msg.textContent = count >= goal
          ? 'Unlocked! Buy 2 Get 2 FREE applied at checkout'
          : 'Add ' + left + (left === 1 ? ' more item' : ' items') + ' to unlock Buy 2 Get 2 FREE';
      }
      wrap.classList.toggle('is-unlocked', count >= goal);

      var ship = wrap.querySelector('[data-bb-ship-msg]');
      if (ship) {
        ship.textContent = cart.total_price >= shipAt
          ? "You've earned free U.S. shipping"
          : money(shipAt - cart.total_price) + ' more for free U.S. shipping';
      }
    }

    // keep the protection toggle honest if the line is removed elsewhere
    var prot = document.querySelector('[data-bb-protection]');
    if (prot) {
      var variant = parseInt(prot.getAttribute('data-variant'), 10);
      var on = cart.items.some(function (l) { return l.variant_id === variant; });
      var input = prot.querySelector('[data-bb-protection-toggle]');
      if (input && input.checked !== on) input.checked = on;
    }
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) render(cart); })
        .catch(function () {});
    }, 120);
  }

  // Protection toggle. Adding is a plain add; removing sets the line to 0,
  // which /cart/change accepts keyed by variant id.
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-bb-protection-toggle]');
    if (!input) return;
    var prot = input.closest('[data-bb-protection]');
    var variant = prot.getAttribute('data-variant');
    input.disabled = true;

    var req = input.checked
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variant), quantity: 1 })
        })
      : fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(variant), quantity: 0 })
        });

    req.then(function () {
      input.disabled = false;
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      refresh();
    }).catch(function () {
      input.disabled = false;
      input.checked = !input.checked;
    });
  });

  // Upsell add buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding...';
    // a card with options carries a picker; fall back to the button's own id
    var card = btn.closest('.bb-upsell__item');
    var picker = card && card.querySelector('.bb-upsell__variant');
    var variantId = picker ? picker.value : btn.getAttribute('data-bb-upsell-add');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function () {
      btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      refresh();
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
    }).catch(function () {
      btn.textContent = label;
      btn.disabled = false;
    });
  });

  ['theme:cart:added', 'theme:cart:update', 'theme:cart:refresh', 'theme:cart:loaded']
    .forEach(function (n) { document.addEventListener(n, refresh); });

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) result.then(refresh, function () {});
      return result;
    };
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
